export const clamp01 = (v: number): number => {
    return Math.max(0, Math.min(1, v));
};
